import request from "@/utils/request";

export default function adminOpenCloseProductLookNum(id,isShowLookNum) {
    return request({
        url: `/storeProduct/agency/openCloseLookNum/`+id+`/`+isShowLookNum,
        method: 'get',
    })
}
